import React from 'react';
import { X } from 'lucide-react';
import placeholderPoster from '../../assets/placeholder-poster.png';

const MovieModal = ({ movie, onClose }) => {
  React.useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.src = placeholderPoster;
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <X size={24} />
        </button>
        <div className="modal-grid">
          <div className="modal-poster">
            <img
              src={movie.posterUrl || placeholderPoster}
              alt={`${movie.name} poster`}
              onError={handleImageError}
            />
          </div>
          <div className="modal-info">
            <h2>{movie.name}</h2>
            <div className="modal-meta">
              <span className="year">{movie.yearRange}</span>
              <span className="rating">IMDB: {movie.imdb}</span>
            </div>
            <p className="modal-description">{movie.description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MovieModal; 